<template>
  <div></div>
</template>

<script>
export default {
  name: 'NtrRegistras',
  created() {
    this.ntrRedirect()
  },
  methods: {
    ntrRedirect() {
      let registrasNr = this.$route.params.registrasNr
      registrasNr = registrasNr.replace('-', '/')

      this.$store
        .dispatch('searchParams', {
          route: 'dokumentai',
          mainData: { reg_nr: `${registrasNr}` },
          extraData: {},
          isExpanded: 0,
        })
        .then(
          this.$router.push({
            name: 'dokumentai',
          })
        )
    },
  },
}
</script>
